import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 27 — Tour del catálogo de Paquetes (combos).
 *
 * Cubre cómo armar un paquete: precio base, productos del catálogo como
 * renglones, sustitutos (1:1 con misma unidad), precio máximo con
 * sustituciones, y toggle ocultar del menú POS.
 */
export const tourPaquetes: TourDefinition = {
  id: 'paquetes',
  title: 'Cómo armar Paquetes (combos)',
  steps: [
    {
      element: '[data-tour="paq-header"]',
      popover: {
        title: '1. Catálogo de paquetes',
        description:
          'Los paquetes son combos del menú: "Espadas Cerdo $500" agrupa varios productos con un precio único más bajo que la suma individual. La idea es vender más rápido y con menos clicks.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="paq-nuevo"]',
      popover: {
        title: '2. Crear un paquete nuevo',
        description:
          'Toca para abrir el formulario. Necesitas: nombre, descripción corta, precio base, categoría, y agregar productos del catálogo como renglones. Mínimo 2 renglones.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="paq-nuevo"]',
      popover: {
        title: '3. Armar los renglones',
        description:
          'Cada renglón es un producto del catálogo con cuántas unidades van. Ejemplo: ×1 "Lomo 1/4 kg", ×2 "Pan Ajo", ×1 "Refresco 600 ml". La unidad la hereda del producto (no la capturas otra vez).',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="paq-nuevo"]',
      popover: {
        title: '4. Sustitutos por renglón',
        description:
          'En cada renglón puedes agregar SUSTITUTOS (productos alternativos que el cliente puede pedir en lugar del default). Ejemplo: en lugar de "Lomo" → "Costilla" (mismo precio = sin cargo) o "Picaña" (más cara = cargo extra automático).',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="paq-nuevo"]',
      popover: {
        title: '5. Precio máximo con sustituciones',
        description:
          'El panel derecho del formulario muestra "Precio máx con sustituciones": si el cliente elige TODOS los sustitutos más caros, ese es el techo. El sistema cobra el delta automático sin que tengas que calcular.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="paq-filtros"]',
      popover: {
        title: '6. Filtrar paquetes',
        description:
          '🟢 En venta = visibles en POS · ⏸ Ocultos = creados pero no se muestran al cliente (útil para combos temporales). Busca por nombre.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="paq-cards"]',
      popover: {
        title: '7. Cards con desglose visible',
        description:
          'Cada card te muestra TODO lo que incluye el paquete sin abrir nada. Si hay sustitutos, aparece "+N sust" en el renglón. El botón 🙈 oculta el paquete del POS al instante (sin abrir formulario).',
        side: 'top',
      },
    },
  ],
};
